import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Calendar, Search, MapPin, Settings, Plus, List } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { RoleGuard, UserOnly, CreatorOnly } from './guards/RoleGuard';
import { Logo } from './Logo';
import { ThemeToggle } from './ui/theme-toggle';


export function Navigation() {
    const location = useLocation();
    const navigate = useNavigate();
    // not used for now, to be determined
    const { user, isUser, isCreator } = useAuth();

    const navItems = [
        { path: '/explore', label: 'Explore', icon: Search },
        { path: '/coming-soon', label: 'Coming Soon', icon: Calendar },
        // { path: '/manage-applications', label: 'Manage Applications', icon: List },
        { path: '/activity-management', label: 'Activity Management', icon: List },
        { path: '/map', label: 'Map', icon: MapPin },
        { path: '/settings', label: 'Settings', icon: Settings },
    ];

    const handleCreateActivity = () => {
        // Dispatch a custom event that the ExploreActivities component can listen to
        // window.dispatchEvent(new CustomEvent('open-create-modal'));
        navigate('/create-activity');
    };

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border/50 shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center">
                        {/* <h1 className="text-xl font-semibold text-primary"><Link to="/explore"><Logo /></Link></h1> */}
                        {/* Logo - responsive */}
                        <div className="flex items-center">
                            {/* Mobile logo: icon only, small size, visible only on small screens */}
                            <Logo
                                showText={false}
                                size="sm"
                                className="sm:hidden"
                            />
                            {/* Desktop logo: icon + text, medium size, hidden on small screens */}
                            <Logo
                                showText={true}
                                size="md"
                                className="hidden sm:flex"
                            />
                        </div>
                    </div>

                    <div className="flex items-center space-x-2">
                        {/* Navigation Items */}
                        <div className="flex space-x-1">
                            {navItems.map(({ path, label, icon: Icon }) => (
                                <Link key={path} to={path}>
                                    <Button
                                        variant={location.pathname === path ? 'default' : 'ghost'}
                                        size="sm"
                                        className="flex items-center space-x-2"
                                    >
                                        <Icon size={16} />
                                        <span className="hidden sm:inline">{label}</span>
                                    </Button>
                                </Link>
                            ))}
                        </div>

                        {/* Create Activity Button */}
                        <Button
                            onClick={handleCreateActivity}
                            size="sm"
                            className="flex items-center space-x-2 ml-2"
                        >
                            <Plus size={16} />
                            <span className="hidden md:inline">Create Activity</span>
                        </Button>

                        {/* Theme Toggle */}
                        <ThemeToggle />
                    </div>
                </div>
            </div>
        </nav>
    );
}
